
export const Services = {
    login: 'auth/sign-in',
    readyAutoLogin: 'login/ussd/auto/ready',
    verifyAutoLogin: 'login/ussd/auto/verify',
    sendSms: 'login/otp/sms/send',
    smsVerify: 'login/otp/sms/verify?otp=',
    ussdVerify: 'login/otp/ussd/verify?otp=',
}